import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFullInventoryFilterForm,
    type StockFullInventoryFilterFormProps,
} from "./components/StockFullInventoryFilter/StockFullInventoryFilterForm";

/** Окна списка АИ для полной инвентаризации склада. */
export const stockFullInventoryListWindows = {
    filter: defineMobileFormWindow<StockFullInventoryFilterFormProps>({
        key: "stock.fullInventory.filter",
        title: "Фильтр АИ для полной инвентаризации склада",
        component: StockFullInventoryFilterForm,
    }),
};
